import { useMutation } from '@tanstack/react-query';
import yookassaUseCase from '../factories/yookassa';

export const useYookassaProxyPayment = () => useMutation(yookassaUseCase.proxyPayments);
